angular.module('vehicle-issue')
    .component('vehicleIssueList', {
        bindings: {
            vehicleId: '<',
            unresolvedOnly: '<'
        },
        templateUrl: 'app/vehicle-issue/_vehicle-issues.html',
        controller: function ($scope, VehicleService, VehicleConst, VehicleIssue, VehicleIssueConst, VehicleIssueService, FilesSimpleUploadService, FilesLibrary) {
            this.VehicleService = VehicleService
            this.VehicleIssueService = VehicleIssueService
            this.FilesSimpleUploadService = FilesSimpleUploadService
            this.FilesLibrary = FilesLibrary

            this.$onInit = () => {
                this.filters = {
                    id: this.vehicleId,
                    size: 10,
                }
                if (this.unresolvedOnly != null) {
                    this.filters.unresolved = this.unresolvedOnly
                }
                this.load()
            }
            this.load = () => {
                let filters = angular.copy(this.filters);
                VehicleIssue.table(filters).$promise.then(result => this.page = result)
            }
            $scope.$on(VehicleIssueConst.eventUpdate, () => this.load())
        }
    })
